import VueRouter from "vue-router";
import routes from "./routes";
import axios from "@/services/axiosInstance";

// configure router
const router = new VueRouter({
  routes, // short for routes: routes
  linkExactActiveClass: "active",
  scrollBehavior: (to) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Navigation guard to check authentication
router.beforeEach(async (to, from, next) => {
  // Allow access to login page without authentication
  if (to.name === 'Login') {
    next();
    return;
  }

  // Check if user is authenticated
  const isAuthenticated = localStorage.getItem('isAuthenticated');
  
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    next({ name: 'Login' });
    return;
  }

  // Verify session is still valid with backend
  try {
    await axios.get('/check-auth');
    next(); // Session is valid, proceed
  } catch (error) {
    // Session expired or invalid
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    next({ name: 'Login' });
  }
});

export default router;
